import i18n from 'i18n'

export const getApiErrorMessage = (errors) => {
  const detail = Array.isArray(errors) ? errors[0] : errors

  return detail ? i18n.t('errors:withDetail', { detail: String(detail) }) : i18n.t('errors:generic')
}
